import { LEARNWORLDS_SESSION_KEY } from 'root-constants'

type TLearnworldsSession = {
  email: string
  token: string
}

// Remembers that this tab already passed the password check, so a refresh mid-flow
// doesn't ask again. Tied to the email it was issued for.
export const getLearnworldsSession = (): TLearnworldsSession | null => {
  const stored = sessionStorage.getItem(LEARNWORLDS_SESSION_KEY)

  if (!stored) return null

  try {
    return JSON.parse(stored)
  } catch {
    return null
  }
}

export const setLearnworldsSession = (session: TLearnworldsSession): void => {
  sessionStorage.setItem(LEARNWORLDS_SESSION_KEY, JSON.stringify(session))
}
